<template>
  <div style="position: relative">
    <!-- 图片预览 -->
    <div v-show="imgsrc" class="avatar-uploader el-upload imgLoadBox">
      <img :src="imgsrc" class="avatar" />
      <div class="imgBoxmMask"></div>
      <i class="el-icon-delete" @click="handleRemove"></i>
      <i class="el-icon-zoom-in" @click="previewImg" :style="{ 'margin-left': '25%' }"></i>
    </div>

    <!-- 上传按钮 -->
    <el-upload
      v-show="!imgsrc"
      class="avatar-uploader"
      action=""
      :show-file-list="false"
      :auto-upload="false"
      @change="handleFileChange"
    >
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>

    <!-- 预览弹窗 -->
    <el-dialog width="30%" :visible.sync="previewVisible">
      <img width="100%" :src="imgsrc" alt="Preview" />
    </el-dialog>
  </div>
</template>

<script>
import { toBlob, getUploadUrl, removeObject, uploadByUrl } from '../../minio/minio';
import { getNowTime, getImgName, getFullImageUrl } from '../../common/publicmethods';
export default {
  // 添加组件名称便于调试
  name: 'ImageUploader',
  props: ['imgsrc', 'filedname'],
  data() {
    return {
      previewVisible: false,
    };
  },
  methods: {
    async handleFileChange(file) {
      try {
        const fileName = getNowTime('time') + file.name;
        const uploadUrl = await getUploadUrl(fileName, '1');

        // 上传文件到MinIO
        await uploadByUrl(uploadUrl, file.raw);

        // 获取完整图片路径
        const relativePath = getImgName(uploadUrl);
        console.log(relativePath, '535345353453453');

        let patUrl = 'https://minio.xyabcd.com/emercontrol/' + relativePath;

        // 更新图片地址
        this.$emit('update:imgsrc', patUrl);
        this.$eventBus.emit('imgUploaded', patUrl, this.filedname);

        this.$message.success('图片上传成功！');
      } catch (error) {
        console.error('上传失败:', error);
        this.$message.error('图片上传失败！');
      }
    },

    async handleRemove() {
      try {
        await this.$confirm('确定删除该图片吗？', '提示', { type: 'warning' });
        const imageName = getImgName(this.imgsrc);
        await removeObject(imageName);

        this.$emit('update:imgsrc', '');
        this.$eventBus.emit('imgRemoved', this.filedname);

        this.$message.success('图片删除成功！');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('图片删除失败！');
        }
      }
    },

    previewImg() {
      this.previewVisible = true;
    },
  },
};
</script>

<style scoped>
/* 图片盒子 */

.imgLoadBox {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  z-index: 9;
  background: #e4e4e4;
}
/* 图片遮罩 */

.imgBoxmMask {
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

/* 删除图标 */

.imgLoadBox > i {
  position: absolute;
  color: #fff;
  font-size: 20px;
  top: 50%;
  left: 37.5%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.imgLoadBox:hover > .imgBoxmMask {
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
}

.imgLoadBox:hover > i {
  opacity: 1;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader :deep().el-upload {
  border: 1px dashed rgba(139, 139, 139, 0.733);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.file {
  width: 178px;
  height: 178px;
  line-height: 178px;
  opacity: 0;
  border-radius: 6px;
  position: absolute;
  top: 1px;
  left: 1px;
  outline: none;
}
.file:hover {
  cursor: pointer;
}
</style>
